import { ChannelMismatchWarning, OfferSendStepView, OfferWizardShellView } from '@today/ui-domain'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useOfferSendStep } from '@/hooks/offers/useOfferSendStep'
import { OFFERS_NAMESPACE } from '@/i18n'
import { OfferWizardStepId, previousStep, stepIndexOf } from './offer-wizard-steps'

/**
 * `/offers/:offerId/send` — Offer Wizard Step 4 (TO-125): access, channels,
 * expiry, confirm and send. Reached from Step 3 or from a DRAFT's detail page.
 */
export function OfferSendPage() {
	const { offerId = '' } = useParams()
	const { t } = useTranslation(OFFERS_NAMESPACE)
	const navigate = useNavigate()
	const { messageWarning, ...step } = useOfferSendStep(offerId)
	const back = previousStep(OfferWizardStepId.SEND)
	return (
		<OfferWizardShellView
			t={t}
			activeStep={stepIndexOf(OfferWizardStepId.SEND)}
			error={null}
			onBack={back ? () => void navigate(back.path(offerId)) : undefined}
		>
			<OfferSendStepView
				t={t}
				{...step}
				messageWarning={messageWarning ? <ChannelMismatchWarning {...messageWarning} /> : null}
			/>
		</OfferWizardShellView>
	)
}
